import {useInView} from "react-intersection-observer";

export const NinthNottingRoomMob = () => {

    const optionsForLowHeight = {
        threshold: 0.1,
        triggerOnce: true
    }

    const [ref2, inView2] = useInView(optionsForLowHeight)
    const [ref3, inView3] = useInView(optionsForLowHeight)

    return (
        <section className="ninth-nt-room-mob">
            <div className="ninth-nt-room-mob__wrapper">
                <div ref={ref2} style={{width: "92vw", height: "70.6vw"}}>
                    {inView2 &&
                        <img
                             className="opacity-animation-1_5s"
                             style={{width: "92vw", height: "70.6vw"}}
                             src="nottingHill/nisec-right-mob.jpg"
                             alt="#"
                        />
                    }
                </div>

                <div ref={ref3} style={{width: "60vw", height: "118.6vw"}}>
                    {inView3 &&
                        <div className="ninth-nt-room-mob__bottom">
                            <img
                                className="opacity-animation-1_5s"
                                style={{width: "60vw", height: "57.3vw"}}
                                src="nottingHill/nisec-left-bot-mob.jpg"
                                alt="#"
                            />

                            <img
                                className="opacity-animation-1_5s"
                                style={{width: "60vw", height: "57.3vw"}}
                                src="nottingHill/nisec-left-top-mob.jpg"
                                alt="#"
                            />

                            <div className="ninth-nt-room-mob__line line opacity-animation-2s"></div>
                        </div>
                    }
                </div>
            </div>
        </section>
    )
}